module.exports = __webpack_public_path__ + "img/sld_scb_19_t1_b1_green.8529c739.svg";